import React from "react";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import TeamSectionStyle2 from "../Section/TeamSection/TeamSectionStyle2";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
const teamData = [
  {
    imgUrl: "/images/doctors/Herman.jpg",
    department: "Spesialis Bedah",
    name: "dr. Herman Susilo, Sp. B, M.Kes",
    designation: "Spesialis Bedah",
    category: "Poli Bedah",
    href: "",
  },
  {
    imgUrl: "/images/doctors/zaki.jpg",
    department: "Spesialis Bedah",
    name: "dr. Ahmad Zaki Rahmani, Sp. B, Finacs",
    designation: "Spesialis Bedah",
    category: "Poli Bedah",
    href: "",
  },
  {
    imgUrl: "/images/doctors/Bram.jpg",
    department: "Spesialis Neurologi",
    name: "dr. Bram Arfian Putra, Sp. N",
    designation: "Spesialis Neurologi",
    category: "Poli Saraf",
    href: "",
  },
  {
    imgUrl: "/images/doctors/Arwindy.jpg",
    department: "Spesialis Penyakit Dalam",
    name: "dr. Arwindy Almar, Sp. PD., FINASIM",
    designation: "Spesialis Penyakit Dalam",
    category: "Poli Penyakit Dalam",
    href: "",
  },
  {
    imgUrl: "/images/doctors/Thabrani.jpg",
    department: "Spesialis Penyakit Dalam",
    name: "dr. Thabrani Putra, Sp. PD",
    designation: "Spesialis Penyakit Dalam",
    category: "Poli Penyakit Dalam",
    href: "",
  },
  {
    imgUrl: "/images/doctors/Lia.jpg",
    department: "Spesialis Anak",
    name: "dr. Lia Kamelia, Sp. A., M. Kes",
    designation: "Spesialis Anak",
    category: "Poli Anak",
    href: "",
  },
  {
    imgUrl: "/images/doctors/ulfa.jpg",
    department: "Spesialis Anak",
    name: "dr. Marselya Ulfa, Sp. A",
    designation: "Spesialis Anak",
    category: "Poli Anak",
    href: "",
  },
  {
    imgUrl: "/images/doctors/hari.jpg",
    department: "Spesialis Kulit & Kelamin",
    name: "dr. Hari Purwanto, sp. D.V",
    designation: "Spesialis Kulit & Kelamin",
    category: "Poli Kulit & Kelamin",
    href: "",
  },
  {
    imgUrl: "/images/doctors/Hermawan.jpg",
    department: "Spesialis THT-KL",
    name: "dr. Hermawan Sutanto, Sp. THT-KL",
    designation: "Spesialis THT-KL",
    category: "Poli THT-KL",
    href: "",
  },
  {
    imgUrl: "/images/doctors/hasan.jpg",
    department: "Spesialis Kandungan",
    name: "dr. Hasan Basri, Sp. OG",
    designation: "Spesialis Kandungan",
    category: "Poli Kandungan",
    href: "",
  },
  {
    imgUrl: "/images/doctors/Bage.jpg",
    department: "Spesialis Kandungan",
    name: "dr. I Wayan Subage, Sp. OG",
    designation: "Spesialis Kandungan",
    category: "Poli Kandungan",
    href: "",
  },
  {
    imgUrl: "/images/doctors/Iksan.jpg",
    department: "Dokter Gigi",
    name: "drg. Iksan Tino Pribadi",
    designation: "Dokter Gigi",
    category: "Poli Gigi",
    href: "",
  },
  {
    imgUrl: "/images/doctors/diana.jpg",
    department: "Dokter Gigi",
    name: "Dr. Diana verawati S",
    designation: "Dokter Gigi",
    category: "Poli Gigi",
    href: "",
  },
  {
    imgUrl: "/images/doctors/siti.jpg",
    department: "Fisioterapi & Rehabilitasi Medik",
    name: "dr. Siti Nurhaidah Sp. K.F.R",
    designation: "Spesialis Kedokteran Fisik dan Rehabilitasi",
    category: "Fisioterapi",
    href: "",
  },
];

export default function Dokter() {
  pageTitle("Dokter");
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/home_1/hero_bg.png"
        imgUrl="/images/doctors/dokter.png"
        title="Dokter Kami"
        subTitle="Melayani dengan sepenuh hati."
      />
      <Section topMd={65} bottomMd={200} bottomLg={150} bottomXl={110}>
        <TeamSectionStyle2 data={teamData} />
      </Section>
    </>
  );
}
